import { listCatalogApi, markAvailableApi, updateCatalogDrugApi } from 'api/drug';
import { catalogActions } from 'store/slices/catalogSlice';

import { handleError } from './errorHandlerThunks';

// Mirrors e-scribe-ui's Formulary screen: the catalog is small enough that the
// whole thing is loaded once and filtered client-side (see updateCatalogSearch),
// rather than paginated like Drug Management.
export const loadCatalog = () => (dispatch) => {
  dispatch(catalogActions.setCatalogLoading(true));

  return listCatalogApi({})
    .then(({ results }) => {
      dispatch(catalogActions.loadCatalog({ drugs: results ?? [] }));
    })
    .catch((error) => {
      dispatch(catalogActions.setCatalogLoading(false));
      dispatch(handleError({ error }));
    });
};

export const updateCatalogSearch = (search) => (dispatch) => {
  dispatch(catalogActions.updateCatalogSearch({ search }));
};

// Both mutations below wait for the reload to finish before resolving --
// dispatching it without awaiting let the caller's success toast (and dialog
// close) fire while the list was still showing its loading state underneath.
export const updateCatalogDrug = (input) => (dispatch) => {
  return updateCatalogDrugApi(input)
    .then((response) => dispatch(loadCatalog()).then(() => response))
    .catch((error) => dispatch(handleError({ error })));
};

export const markCatalogAvailability = (input) => (dispatch) => {
  return markAvailableApi(input)
    .then((response) => dispatch(loadCatalog()).then(() => response))
    .catch((error) => dispatch(handleError({ error })));
};
